export default __webpack_public_path__ + "static/media/access-denied.ffa28abf.svg";